/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Streamerreport_Games_Body1Inputs */

const ja_playdata_streamerreport_games_body1 = /** @type {(inputs: Playdata_Streamerreport_Games_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各ゲームタイトルにおいて、どのストリーマーが注目されているか、またそのゲームの人気度の変化も把握できます。`)
};

const en_playdata_streamerreport_games_body1 = /** @type {(inputs: Playdata_Streamerreport_Games_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For any game title, see which streamers are getting attention and how that title's popularity is changing over time.`)
};

/**
* | output |
* | --- |
* | "For any game title, see which streamers are getting attention and how that title's popularity is changing over time." |
*
* @param {Playdata_Streamerreport_Games_Body1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_streamerreport_games_body1 = /** @type {((inputs?: Playdata_Streamerreport_Games_Body1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Streamerreport_Games_Body1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_streamerreport_games_body1(inputs)
	return en_playdata_streamerreport_games_body1(inputs)
});
export { playdata_streamerreport_games_body1 as "playdata_streamerReport_games_body" }